import Axios from "@app/api/axios";
import config from "@src/config";

export const getPersonDetails = async (
  BrickId,
  maxAge = 12 * 60 * 60 * 1000
) => {
  const body = JSON.stringify([
    "BrickId",
    "BirthDate",
    "FirstName",
    "LastName",
    "Email",
    "IsNaturalPerson",
    "ResellerId",
    "ResellerNo",
    "ResellerAccount",
    "AddressCity",
    "AddressStreet",
    "PhoneHome",
    "PhoneWork",
    "PhoneMobile",
    "Country",
    "UserDomain",
  ]);

  try {
    const response = await Axios.post(
      `${config.BASE_URL}person-by-brick-id?brickId=${BrickId}`,
      body,
      {
        cache: { maxAge },
      }
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    //catch error
  }
};
export default getPersonDetails;

export const getPersonByPersonalNumber = async (
  maxAge = 12 * 60 * 60 * 1000
) => {
  const body = JSON.stringify([
    // fields for getPersonByPersonalNumber
    [
      "BrickId",
      "BirthDate",
      "FirstName",
      "LastName",
      "Email",
      "IsNaturalPerson",
      "ResellerId",
      "ResellerNo",
      "ResellerAccount",
      "AddressCity",
      "AddressStreet",
      "PhoneHome",
      "PhoneWork",
      "PhoneMobile",
      "Country",
      "UserDomain",
    ],
  ]);

  try {
    const response = await Axios.post(
      `${config.BASE_URL}person-by-personal-number`,
      body,
      {
        cache: { maxAge },
      }
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    //catch error
  }
};

export const getNotifications = async (aws, BrickId) => {
  const request = await aws.sign(
    `${config.BASE_URL}person-messages?brickId=${BrickId}`,
    {
      method: "POST",
      body: JSON.stringify([
        // messages
        [
          "BrickId",
          "CreatedDate",
          "Receiver",
          "Subject",
          "Body",
          "IsRead",
          "IsPublic",
          "IsPromoted",
          "EventDate",
          "IsHTML",
          "Priority",
          "Status",
        ],
      ]),
    }
  );

  try {
    const response = await fetch(request);
    return await response.json();
  } catch (err) {
    //catch error
  }
};

export const getPersonDocuments = async (
  BrickId,
  maxAge = 12 * 60 * 60 * 1000
) => {
  const body = JSON.stringify([
    // file list
    [
      "BrickId",
      "CreatedDate",
      "Name",
      "FileSize",
      "FilePermission",
      "FileContext",
    ],
  ]);

  try {
    const response = await Axios.post(
      `${config.BASE_URL}person-file-list?brickId=${BrickId}`,
      body,
      {
        cache: { maxAge },
      }
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    //catch error
  }
};

export const updateNotification = async (aws, data) => {
  const request = await aws.sign(`${config.BASE_URL}message`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

  try {
    const response = await fetch(request);
    return await response.json();
  } catch (err) {
    //catch error
  }
};
